module.exports = __webpack_public_path__ + "media/src/images/icon/images-0ce941d14143e00e4e43a12875b50830.png";